<template>
  <div
    class="goodsBigScreen"
    id="goodsBigScreen"
    :style="{ backgroundImage: `url(${backgroundImage})`,color:textColor }"
  >
    <div class="left">
      <div class="tit">制作中</div>
      <div class="sub-tit">PREPARING</div>
      <div class="list" v-if="ingOrder.length">
        <span class="item" :class="{bold:isBold==1}" v-for="(it, ind) in ingOrder" :key="ind">
          {{ it.code }}
        </span>
      </div>
      <div class="list no-data" v-else>暂无数据...</div>
    </div>
    <div class="right">
      <div class="tit">请取餐</div>
      <div class="sub-tit">READY</div>
      <div class="list" v-if="deliveryOrder.length">
        <span class="item" v-for="(it, ind) in deliveryOrder" :key="ind"
          ><div class="cont" :class="{bold:isBold==1}">
            {{ it.code }}
            <div class="emp-name">
              ({{ it.deliveryName ? `${it.deliveryName}~` : ""
              }}{{ it.tableNo ? `${it.tableNo}号机~` : ""
              }}{{ formatTime(it.makeTime) }})
            </div>
          </div>
        </span>
      </div>
      <div class="list no-data" v-else>暂无数据...</div>
      <div class="pls-get" v-if="showGetOrder">
        <div class="tit-wrap">
          <div class="pls-tit">请取餐</div>
          <div class="pls-sub-tit">READY</div>
        </div>
        <div class="inner-wrap">
          <div class="num">
            {{ nowGetItem.code }}
            <div class="emp-name">{{ nowGetItem.deliveryName }}</div>
          </div>
        </div>
      </div>
    </div>
    <form class="submit-code" @submit.prevent="checkOrder">
      <input class="inp" id="inp" autofocus type="password" v-model="code" />
    </form>
  </div>
</template>
<script>
import { API_BASE_URL, WS_API_URL } from "@/urlConfig/index";
const normalBg = require("@/assets/index/screen_normal.png");

export default {
  name: "goodsBigScreen",
  props: ["curStoreId"],
  data() {
    return {
      isBold:"-1",
      textColor:"#333",
      makeBackUrl:{},
      timer: null,
      backgroundImage: "",
      codeArr: [],
      nowGetItem: null,
      code: "",
      showGetOrder: false,
      deliveryOrder: [],
      ingOrder: [],
      status: true,
      stompClient: null, // stomp客户端对象
      stompClientNotice: null, // stomp客户端对象(语音服务)
    };
  },
  methods: {
    formatTime(time) {
      const nowTime = new Date().getTime();
      const makeTime = new Date(time).getTime();
      const minTimes = nowTime - makeTime;
      if (Math.floor(minTimes / 1000 / 60) < 1) {
        return "已等待0分钟";
      } else {
        return `已等待${Math.floor(minTimes / 1000 / 60)}分钟`;
      }
    },
    getStoreInfo() {
      this.$http({
        url: `stores/${this.curStoreId}`,
        method: "GET",
      }).then((res) => {
        // if (res.data.makeBackUrl) {
        //   this.backgroundImage = res.data.makeBackUrl;
        // } else {
        //   this.backgroundImage = normalBg;
        // }
        if(res.data.makeBackUrl && res.data.makeBackUrl.indexOf("{")!=-1){
          this.makeBackUrl = JSON.parse(res.data.makeBackUrl);
          if(this.makeBackUrl.hasOwnProperty("textColor") && this.makeBackUrl.textColor){
            this.textColor = this.makeBackUrl.textColor;
          }
          if(this.makeBackUrl.hasOwnProperty("isBold")){
            this.isBold = this.makeBackUrl.isBold;
          }else{
            this.isBold = "-1";
          }
        }else{
          this.makeBackUrl = {
            bg:res.data.makeBackUrl,
            textColor:"#333",
            isBold:"-1",
          }
          this.textColor = this.makeBackUrl.textColor;
          this.isBold = this.makeBackUrl.isBold;
        }
        if (this.makeBackUrl&&this.makeBackUrl.bg) {
          this.backgroundImage = this.makeBackUrl.bg;
        } else {
          this.backgroundImage = normalBg;
        }
        console.log("bold",this.isBold)
      });
    },
    //
    connect() {
      let authStr = localStorage.getItem("token");
      let socket = new SockJS(WS_API_URL + "gs-guide-websocket");
      this.stompClient = Stomp.over(socket);
      let that = this;
      this.stompClient.connect({ "Auth-Token": authStr }, function (frame) {
        that.stompClient.ws.onerror = function (evnt) {
          that.connect();
        };
        that.stompClient.ws.onclose = function (evnt) {
          that.connect();
        };
        that.stompClient.subscribe(
          "/message/" + that.curStoreId,
          function (event) {
            console.log("我收到了服务器消息");
            let res = JSON.parse(event.body);
            console.log("source", res.source);
            if (res.source == "MAKE") {
              that.getData();
            }
          }
        );
      });
      this.stompClient.ws.onclose = function (evnt) {
        setTimeout(() => {
          that.connect();
        }, 1000);
      };
      this.stompClient.debug = function (str) {
        console.log(str);
      };
    },
    disconnect() {
      if (this.stompClient !== null) {
        this.stompClient.disconnect();
      }
    },
    //
    checkInputFocus(selector) {
      document.getElementById("inp").focus();
      setTimeout(function () {
        let input = document.querySelector(selector);
        if (input === document.activeElement) {
          console.log("focused");
        } else {
          document.getElementById("inp").focus();
        }
      }, 100);
    },
    test(it) {
      this.code = it;
      this.checkOrder();
    },
    checkOrder() {
      console.log("code", this.code);
      let itemIds = [];
      if (this.code) {
        itemIds = this.code.split(";");
      }
      if (!itemIds.length) {
        return;
      }
      this.code = "";
      this.$http({
        url: "/update/type",
        method: "POST",
        data: {
          itemIds,
          type: "deliveryIng",
        },
      }).then((res) => {
        console.log("res", res);
        try {
          this.nowGetItem = res.data[0];
          this.showGetOrder = true;
          this.getData();
        } catch (error) {
          console.log("error", error);
        }
        // this.playVoice(res.data[0].code);
        setTimeout(() => {
          this.showGetOrder = false;
        }, 4599);
      });
    },
    playVoice(code) {
      return;
      let codeArr = JSON.parse(JSON.stringify(this.codeArr));
      codeArr.push(code);
      codeArr = [...new Set(codeArr)];
      //
      let _this = this;
      if (codeArr && codeArr.length) {
        let audioIndex = 0;
        function playAudio(audioIndex) {
          if (audioIndex < codeArr.length) {
            let audio = `<audio style="display:none;" controls="" class="getAudio" src="${API_BASE_URL}v1/pos/speech?tex=${codeArr[audioIndex]},请取餐&vol=9&per=0&spd=5&pit=5" autoplay="autoplay"></audio>`;
            $("#goodsBigScreen").append(audio);

            $(".getAudio").on("playing", function () {
              _this.status = false; //正在播放
              console.log("正在播放");
            });
            $(".getAudio").on("ended", function () {
              this.remove();
              playAudio(audioIndex + 1);
            });
          } else {
            console.log("播放完毕");
          }
        }
        playAudio(audioIndex);
        return;
      }
      //
      // $(".getAudio").remove();
      // let audio = `<audio style="display:none;" controls="" class="getAudio" src="${API_BASE_URL}v1/pos/speech?tex=${code},请取餐&vol=9&per=0&spd=5&pit=5" autoplay="autoplay"></audio>`;
      // $("#goodsBigScreen").append(audio);
      // try {
      //   $(".getAudio").remove();
      // } catch (error) {}
    },
    getData() {
      this.$http({
        url: "/get/by/type",
        method: "POST",
        data: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        console.log("res", res);
        if (
          res.data &&
          res.data.hasOwnProperty("ingItem") &&
          res.data.hasOwnProperty("deliveryItem")
        ) {
          this.ingOrder = Array.isArray(res.data.ingItem)
            ? res.data.ingItem
            : [];
          this.deliveryOrder = Array.isArray(res.data.deliveryItem)
            ? res.data.deliveryItem
            : [];
        }
      });
    },
  },
  beforeDestroy() {
    this.disconnect();
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted() {
    this.getStoreInfo();
    this.connect();
    this.timer = setInterval(() => {
      this.getData();
    }, 1000);
    this.checkInputFocus("input.inp");
    setInterval(() => {
      this.checkInputFocus("input.inp");
    }, 1000 * 60);
  },
};
</script>
<style scoped lang="scss">
@font-face {
  font-family: "MyCustomFont";
  src: url("./苹方黑体-准-简.ttf") format("truetype");
}
.goodsBigScreen {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  background-repeat: no-repeat;
  /* background-size: cover; */
  background-size: 100% 100%;
  background-position: center center;
  * {
    font-family: "MyCustomFont", sans-serif;
    text-shadow: 5px 5px 5px rgba(255, 255, 255, 0.5);
    &.bold{
      font-weight: bold!important;
    }
  }
  & {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  &::-webkit-scrollbar {
    scrollbar-width: none;
    -ms-overflow-style: none;
    display: none;
  }
  .left,
  .right {
    width: 50%;
    height: 100%;
  }
  .left,
  .right {
    // background-color: #eee;
    .tit {
      text-align: center;
      /* font-size: 32px; */
      font-size: 59px;
      padding-top: 40px;
      letter-spacing: 5px;
    }
    .sub-tit {
      /* font-size: 14px; */
      font-size: 24px;
      text-align: center;
      padding-top: 10px;
    }
    .list {
      height: calc(100% - 100px);
      overflow: hidden;
      overflow-y: auto;
      padding: 20px;
      box-sizing: border-box;
      .emp-name {
        font-size: 40px;
        padding-top: 5px;
        white-space: nowrap;
      }
      & {
        scrollbar-width: none;
        -ms-overflow-style: none;
      }
      &::-webkit-scrollbar {
        scrollbar-width: none;
        -ms-overflow-style: none;
        display: none;
      }
      .item {
        width: 25%;
        text-align: center;
        display: inline-block;
        padding: 30px;
        box-sizing: border-box;
        font-size: 59px;
        vertical-align: top;
        /* font-weight: bold; */
      }
    }
  }
  .right {
    // background-color: #f4f4f4;
    position: relative;
    .pls-get {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9;
      background-color: #fff;
      display: flex;
      flex-wrap: wrap;
      .tit-wrap {
        width: 100%;
        height: 150px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: center;
        .pls-tit,
        .pls-sub-tit {
          width: 100%;
          display: flex;
          justify-content: center;
        }
        .pls-tit {
          font-size: 42px;
          letter-spacing: 9px;
        }
        .pls-sub-tit {
          font-size: 16px;
          font-weight: 400;
          padding-top: 10px;
        }
      }
      .inner-wrap {
        width: 100%;
        height: calc(100% - 150px);
        overflow: hidden;
        display: flex;
        justify-content: center;
        padding-top: 25%;
        box-sizing: border-box;
        text-align: center;
        flex-wrap: wrap;
        .num {
          width: 100%;
        }
        .emp-name {
          font-size: 28px;
          padding-top: 5px;
          letter-spacing: 5px;
        }
      }
      .num {
        font-size: 100px;
        letter-spacing: 9px;
      }
    }
    .item {
      width: 100% !important;
      text-align: center;
      display: inline-block;
      padding: 30px;
      box-sizing: border-box;
      font-size: 59px;
      vertical-align: top;
      /* font-weight: bold; */
      .cont{
        display: flex;
        align-items: center;
        /* justify-content: center; */
        .emp-name {
          font-size: 36px;
          letter-spacing: 5px;
          font-weight: 400;
          opacity: 0.9;
        }
      }
    }
  }
  .inp {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    opacity: 0;
    cursor: pointer;
  }
}
.no-data {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// index.vue?6f0e4722